import { render, staticRenderFns } from "./ParentViewUserInfoCard.vue?vue&type=template&id=2764f108&"
import script from "./ParentViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./ParentViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports